import React from 'react';
import { translate } from 'react-i18next';
import {
  Image,
  ImageBackground,
  Platform,
  SafeAreaView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import Logo from '../assets/images/logo-black.png';
import WelcomeBackground from '../assets/images/welcome2-background.png';
import { Button, ButtonSize, Icon } from '../components';
import Theme from '../theme';
import { defaultScale, scaleImageAspectRatio } from '../utils/scaling';
import { isMobile, minDesktopWidth } from '../utils/ScreenSizes';

interface IProps {
  avatar: string | null;
  influencerName: string;
  navigation: any;
  personalisedHeader: string | undefined;
  t(key: string, options?: any): string;
}

export class InfluencerNoScheduleScreenComponent extends React.PureComponent<IProps> {

  public handleNavigation= () => {
    const routeToNavigate = Platform.OS === 'web' ? 'HomeNavigator' : 'HomeLoading';
    this.props.navigation.navigate(routeToNavigate);
  }

  public render() {
    const { avatar, t, influencerName } = this.props;
    const imageSource = avatar
      ? { uri: `data:image/png;base64,${avatar}` }
      : WelcomeBackground;

    return (
      <View style={styles.container}>
        <ImageBackground
          source={imageSource}
          style={styles.imageStyle}
        >
          <SafeAreaView style={{ flex: 0 }} />
          <TouchableOpacity onPress={this.handleNavigation} style={styles.closeButton}>
            <Icon name='md-close' color={Theme.WHITE} size={defaultScale(35)} />
          </TouchableOpacity>
        </ImageBackground>
        <View style={styles.contentContainer}>
          <Image source={Logo} style={styles.logo} />
          <Text style={styles.influencerNameText}>
            {t('influencerNameText',
              { influencer: influencerName, personalisedHeader: this.props.personalisedHeader || 'Fitillion' },
            )}
          </Text>
          <Text style={styles.noScheduletext}>
            {t('influencerNoSchedule', { personalisedHeader: this.props.personalisedHeader || 'Fitillion' })}
          </Text>
        </View>
        <SafeAreaView>
          <Button
            fontColor={Theme.WHITE}
            size={ButtonSize.MEDIUM}
            onPress={this.handleNavigation}
            title={t('continueToFitillion')}
            containerStyle={styles.button}
          />
        </SafeAreaView>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    ...Platform.select({
      web: {
        width: isMobile() ? '100%' : minDesktopWidth,
      },
    }),
    height: '100%',
    backgroundColor: Theme.WHITE,
  },
  contentContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    margin: defaultScale(12),
  },
  logo: {
    height: defaultScale(41),
    width: defaultScale(175),
    marginTop: defaultScale(16),
  },
  imageStyle: {
    ...Platform.select({
      web: {
        height: isMobile() ? window.innerWidth : minDesktopWidth,
      },
      default: {
        aspectRatio: scaleImageAspectRatio(0.9),
      },
    }),
    width: '100%',
  },
  button: {
    marginTop: defaultScale(40),
    marginBottom: defaultScale(12),
    marginHorizontal: defaultScale(12),
  },
  noScheduletext: {
    marginTop: defaultScale(16),
    textAlign: 'center',
    ...Theme.textStyle.bodyCopyReg,
  },
  influencerNameText: {
    marginTop: defaultScale(35),
    ...Theme.textStyle.heading,
  },
  closeButton:{
    alignSelf: 'flex-end',
    ...Platform.select({
      android: { paddingTop:defaultScale(15), paddingRight: defaultScale(15) },
      default: { paddingRight: defaultScale(15)},
    }),
  },
});

export const InfluencerNoScheduleScreen = translate(['bookings'], {
  wait: true,
})(InfluencerNoScheduleScreenComponent);
